(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-newsletter-tab"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('.mr-side-tab');
    if (!root) return;

    const openButton = root.querySelector('.mr-side-tab__open');
    const closeButton = root.querySelector('.mr-side-tab__close');
    const formId = root.dataset.formId;
    const parsedThreshold = parseInt(root.dataset.threshold, 10);
    const threshold = Number.isNaN(parsedThreshold) ? 500 : parsedThreshold;
    const cartSelector = 'html.kaching-body__cart-open, #kaching-cart[data-open="true"], cart-drawer[open]';
    const storageKey = 'mr-side-tab-dismissed';

    let dismissed = false;
    try {
      dismissed = sessionStorage.getItem(storageKey) === '1';
    } catch (error) {
      dismissed = false;
    }

    function update() {
      const cartOpen = document.querySelector(cartSelector) !== null;
      const scrolledEnough = window.scrollY >= threshold;
      const show = !dismissed && scrolledEnough && !cartOpen;
      root.dataset.state = show ? 'visible' : 'hidden';
    }

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        update();
      });
    }

    openButton.addEventListener('click', () => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });

    closeButton.addEventListener('click', () => {
      dismissed = true;
      try {
        sessionStorage.setItem(storageKey, '1');
      } catch (error) {
        dismissed = true;
      }
      update();
    });

    window.addEventListener('scroll', onScroll, { passive: true });

    new MutationObserver(update).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    new MutationObserver(update).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-open', 'open']
    });

    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!window.productGalleryMoreBound) {
    window.productGalleryMoreBound = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-gallery-more]');
      if (!button) return;
      const gallery = button.closest('.product-gallery');
      if (gallery) gallery.classList.remove('product-gallery--collapsed');
      button.setAttribute('aria-expanded', 'true');
      button.hidden = true;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 999px)');
        this.onMediaChange = () => this.sync();
        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.build();
        this.sync();
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
      }

      get isActive() {
        return this.getAttribute('mode') === 'tabs' || this.mediaQuery.matches;
      }

      get panels() {
        if (!this._panels) {
          this._panels = Array.from(this.querySelectorAll(':scope > .product-info__block-item > accordion-disclosure > details')).filter((panel) => {
            const content = panel.lastElementChild;
            const hasContent = content && (content.textContent.trim() !== '' || content.querySelector('img, table, video, iframe, svg'));
            if (!hasContent) {
              panel.closest('.product-info__block-item').hidden = true;
            }
            return hasContent;
          });
        }
        return this._panels;
      }

      build() {
        if (this.querySelector('.product-tabs__nav')) {
          return;
        }
        const uid = Math.random().toString(36).slice(2, 8);
        const nav = document.createElement('div');
        nav.className = 'product-tabs__nav';
        nav.setAttribute('role', 'tablist');
        nav.addEventListener('scroll', () => {
          nav.classList.toggle('is-scrolled-end', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2);
        }, { passive: true });
        this.panels.forEach((panel, index) => {
          const summary = panel.querySelector('summary');
          const button = document.createElement('button');
          button.type = 'button';
          button.id = `product-tab-${uid}-${index}`;
          button.className = 'product-tabs__tab h6';
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', `product-tabpanel-${uid}-${index}`);
          button.textContent = summary ? summary.textContent.trim() : '';
          button.addEventListener('click', () => this.activate(index));
          button.addEventListener('keydown', (event) => this.onKeydown(event, index));
          nav.appendChild(button);
          const content = panel.lastElementChild;
          if (content) {
            content.id = `product-tabpanel-${uid}-${index}`;
            content.setAttribute('role', 'tabpanel');
            content.setAttribute('aria-labelledby', button.id);
          }
        });
        this.prepend(nav);
        this.activeIndex = Math.max(0, this.panels.findIndex((panel) => panel.open));
      }

      onKeydown(event, index) {
        const count = this.panels.length;
        let next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % count;
        if (event.key === 'ArrowLeft') next = (index - 1 + count) % count;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = count - 1;
        if (next === null) return;
        event.preventDefault();
        this.activate(next);
        const tab = this.querySelectorAll('.product-tabs__tab')[next];
        if (tab) tab.focus();
      }

      activate(index) {
        this.activeIndex = index;
        this.sync();
        const tab = this.querySelectorAll('.product-tabs__tab')[index];
        if (tab) {
          tab.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        }
      }

      sync() {
        const active = this.isActive;
        this.classList.toggle('product-tabs--active', active);
        this.querySelectorAll('.product-tabs__tab').forEach((tab, index) => {
          const selected = index === this.activeIndex;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        if (!active) {
          return;
        }
        this.panels.forEach((panel, index) => {
          const selected = index === this.activeIndex;
          panel.open = selected;
          panel.setAttribute('aria-expanded', selected ? 'true' : 'false');
          panel.style.height = '';
          panel.style.overflow = '';
          const content = panel.lastElementChild;
          if (content) {
            content.style.opacity = '';
            content.style.transform = '';
          }
        });
      }
    }
    window.customElements.define('product-tabs', ProductTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
